var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C20.3869 8 22.6761 8.94821 24.364 10.636C26.0518 12.3239 27 14.6131 27 17C27 20.074 25.324 22.59 23.558 24.395C22.6755 25.2869 21.7128 26.0956 20.682 26.811L20.256 27.101L20.056 27.234L19.679 27.474L19.343 27.679L18.927 27.921C18.6445 28.0818 18.325 28.1663 18 28.1663C17.675 28.1663 17.3555 28.0818 17.073 27.921L16.657 27.679L16.137 27.359L15.945 27.234L15.535 26.961C14.423 26.2083 13.3871 25.3489 12.442 24.395C10.676 22.589 9 20.074 9 17C9 14.6131 9.94821 12.3239 11.636 10.636C13.3239 8.94821 15.6131 8 18 8ZM18 14C17.606 14 17.2159 14.0776 16.8519 14.2284C16.488 14.3791 16.1573 14.6001 15.8787 14.8787C15.6001 15.1573 15.3791 15.488 15.2284 15.8519C15.0776 16.2159 15 16.606 15 17C15 17.394 15.0776 17.7841 15.2284 18.1481C15.3791 18.512 15.6001 18.8427 15.8787 19.1213C16.1573 19.3999 16.488 19.6209 16.8519 19.7716C17.2159 19.9224 17.606 20 18 20C18.7956 20 19.5587 19.6839 20.1213 19.1213C20.6839 18.5587 21 17.7956 21 17C21 16.2044 20.6839 15.4413 20.1213 14.8787C19.5587 14.3161 18.7956 14 18 14Z",
    fill: "#006DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.0ececfbc9460224eb9d917612c8483ca.svg";
export { ForwardRef as ReactComponent };